import { render, staticRenderFns } from "./BulkAssignAwb.vue?vue&type=template&id=0b14a041"
import script from "./BulkAssignAwb.vue?vue&type=script&lang=js"
export * from "./BulkAssignAwb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports